/**
 * Facet drawer mechanics — port of FilterDrawer.tsx behavior:
 * - open via [data-facet-open] (toolbar), close via backdrop / X / Esc
 * - body scroll lock while open; focus moves into the panel after 50ms
 * - 280ms panel slide + 300ms backdrop fade are pure CSS (.is-open)
 * Filtering is REAL (Search & Discovery): any checkbox change serializes the
 * form into filter.* URL params and dispatches `dylys:facet-change`;
 * collection.js fetches the section and swaps the DOM (D3 — no navigation).
 * Price buckets are exclusive (one gte/lte range at a time).
 */
(function () {
  'use strict';

  function init(drawer) {
    if (drawer.dataset.facetInit) return;
    drawer.dataset.facetInit = '1';

    var panel = drawer.querySelector('[data-facet-panel]');
    var form = drawer.querySelector('[data-facet-form]');
    var isOpen = false;

    function setOpen(open) {
      isOpen = open;
      drawer.classList.toggle('is-open', open);
      if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) window.Dylys.lockScroll(); else window.Dylys.unlockScroll();
      if (open) {
        setTimeout(function () {
          var first = panel && panel.querySelector('button, [tabindex="0"], input');
          if (first) first.focus();
        }, 50);
      }
    }

    drawer.open = function () { setOpen(true); };
    drawer.close = function () { setOpen(false); };

    drawer.querySelectorAll('[data-facet-close]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    var resultsBtn = drawer.querySelector('[data-facet-close-on-click]');
    if (resultsBtn) {
      resultsBtn.addEventListener('click', function () { setOpen(false); });
    }

    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) setOpen(false);
    });

    function serialize() {
      var params = new URLSearchParams();

      // Preserve the current sort and grouped-sort mode
      var current = new URLSearchParams(window.location.search);
      if (current.get('sort_by')) params.set('sort_by', current.get('sort_by'));
      if (current.get('group_by')) params.set('group_by', current.get('group_by'));

      if (form) {
        form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
          if (input.hasAttribute('data-price-bucket')) {
            if (input.dataset.priceGte) params.set(input.dataset.gteParam, input.dataset.priceGte);
            if (input.dataset.priceLte) params.set(input.dataset.lteParam, input.dataset.priceLte);
          } else if (input.name) {
            params.append(input.name, input.value);
          }
        });
      }
      return params;
    }

    function emitChange() {
      drawer.dispatchEvent(new CustomEvent('dylys:facet-change', {
        bubbles: true,
        detail: { params: serialize().toString() }
      }));
    }

    if (form) {
      form.addEventListener('change', function (e) {
        var input = e.target;
        if (input.type !== 'checkbox') return;
        // Price buckets behave as an exclusive range (native price filter)
        if (input.hasAttribute('data-price-bucket') && input.checked) {
          form.querySelectorAll('[data-price-bucket]').forEach(function (other) {
            if (other !== input) other.checked = false;
          });
        }
        emitChange();
      });
    }

    // Long value lists (Farbe, Material) collapse to 10 rows instead of
    // forcing a nested scroll area inside the drawer.
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-facet-more]') : null;
      if (!btn) return;
      var list = btn.parentNode.querySelector('[data-facet-collapsible]');
      if (!list) return;
      var collapsed = list.classList.toggle('facet-group__options--collapsed');
      btn.textContent = collapsed ? btn.dataset.labelMore : btn.dataset.labelLess;
    });

    var resetBtn = drawer.querySelector('[data-facet-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        if (form) {
          form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
            input.checked = false;
          });
        }
        // A legacy tag path (/collections/x/tag) filters outside the form —
        // resetting must leave it (sort survives via serialize()).
        var baseUrl = drawer.dataset.collectionUrl;
        if (baseUrl && window.location.pathname !== baseUrl) {
          var qs = serialize().toString();
          window.location.href = baseUrl + (qs ? '?' + qs : '');
          return;
        }
        emitChange();
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-facet-drawer]').forEach(init);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  window.Dylys = window.Dylys || {};
  window.Dylys.initFacetDrawers = initAll;
})();
